// The configurator's three languages (CDC, "Langues"). Whatever GobeletCup types in the
// back-office and the customer reads is entered in each of them (Katia, 2026-10-06).

type TAdminLocale = 'en' | 'fr' | 'pt';

interface IAdminLocalized {
    en: string;
    fr: string;
    pt: string;
}

interface IAdminLocalizedTags {
    en: string[];
    fr: string[];
    pt: string[];
}

// What a classification entry carries besides its French label, which the lists key on.
interface IAdminTranslations {
    en: string;
    pt: string;
}

const ADMIN_LOCALES: { key: TAdminLocale; label: string; name: string }[] = [
    { key: 'fr', label: 'FR', name: 'Français' },
    { key: 'en', label: 'EN', name: 'Anglais' },
    { key: 'pt', label: 'PT', name: 'Portugais' },
];

function localized(fr: string, en = '', pt = ''): IAdminLocalized {
    return { fr, en, pt };
}

function localizedTags(fr: string[] = [], en: string[] = [], pt: string[] = []): IAdminLocalizedTags {
    return { fr, en, pt };
}

export { ADMIN_LOCALES, localized, localizedTags };

export type { IAdminLocalized, IAdminLocalizedTags, IAdminTranslations, TAdminLocale };
